import { setupPage } from 'csstips'
import React, { Suspense, lazy } from 'react'
import * as AppStyle from './styles/App.style'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ROUTER_BASENAME } from '@/services/path'
import { cnzzSendObjectEvent, getPlatform, isIOS } from '@/utils/tools'
import { Dialog } from './components/Dialog/Dialog'
import Home from './views/Home/Home'
import FreeLecture from './views/FreeLecture/FreeLecture'
import Punch from './views/Punch/Punch'
import SearchPage from './views/Home/components/HomeSearchPage/HomeSearchPage'
import MyPunchCoupon from './views/Punch/MyPunchCoupon/MyPunchCoupon'
import SearchResult from './views/SearchResult/SearchResult'
import MoreLiveRoom from './views/SearchResult/MoreLiveRoom/MoreLiveRoom'
import MoreChannel from './views/SearchResult/MoreChannel/MoreChannel'
import { isAndroid } from './utils/tools'

declare const document: any

export interface IhistoryProps {
  history: any
}

// if (window.location.hostname === 'm.lizhiweike.com' && (window as any).Raven) {
// (window as any).Raven.config('http://acb83c914b744a8da842fe7ae26448b5@sentry.lizhiweike.com/39').install()
// }

// 滑动 1px
const move1px = () => {
  setTimeout(() => {
    window.scrollTo(window.pageXOffset, window.pageYOffset + 1)
  }, 100)
}
document.addEventListener('focusout', move1px)

setupPage(AppStyle.main)

/* 别的页面返回首页在ios上会闪烁一下，用这个方法暂时缓解一下，找到方法再移除 */
let closeTimeflag = 200
if (window.sessionStorage.getItem('WKindex-splash-count') && isIOS()) {
  closeTimeflag = 500
} else {
  window.sessionStorage.setItem('WKindex-splash-count', '1')
}

/* 去掉Splash加载画面 */
if (document.getElementById('splash')) {
  function removeSplash() {
    /** 劫持情况下的处理 */
    if (isAndroid() && /hijack=true/.test(location.href) && sessionStorage.getItem('__closeWindow__')) {
      return '处于管理员/cps/sass系统，不显示页面'
    }
    if (navigator.appName === 'Microsoft Internet Explorer') {
      setTimeout(() => {
        document.getElementById('splash').removeNode(true)
      }, closeTimeflag)
    } else {
      setTimeout(() => {
        document.getElementById('splash').remove()
      }, closeTimeflag)
    }
  }
  removeSplash()
}

try {
  cnzzSendObjectEvent({
    page: 'homepage_first_enter',
    action: `platform=${getPlatform()}`
  })
  if (window.location.search.indexOf('from') !== -1 && document.referrer) {
    console.log('统计劫持', document.referrer)
    cnzzSendObjectEvent({
      page: 'home_kidnap',
      action: `platform=${getPlatform()}`
    })
  }
  const wkKidnapFrom = window.sessionStorage.getItem('wk_kidnap_from')
  if (wkKidnapFrom && wkKidnapFrom !== 'indexpage') {
    cnzzSendObjectEvent({
      page: `kidnap_fr_${wkKidnapFrom}`,
      action: `platform=${getPlatform()}`
    })
    window.sessionStorage.setItem('wk_kidnap_from', 'indexpage')
  }
} catch (error) {
  console.log(error)
}

export class App extends React.Component<IhistoryProps> {
  public render() {
    if (['m.fswkv.cn', 'm.shifangfm.com', 'm.tjfaaf.com'].includes(location.hostname) || /alipay/i.test(navigator.userAgent)) {
      return (
        <div className={AppStyle.main}>
          <BrowserRouter basename={ROUTER_BASENAME}>
            <Dialog />
            {/* <Suspense fallback={<Loading/>}> */}
            <Switch>
              <Route path="/" exact={true} component={Home} />
              <Route path="/category" component={Home} />
              <Route path="/freelecture" component={FreeLecture} />
              <Route path="/punch" component={Punch} />
              {/* <Route path="/searchpage" component={SearchPage} /> */}
              <Route path="/search-result" component={SearchResult} />
              <Route path="/more-liveroom" component={MoreLiveRoom} />
              <Route path="/more-channel" component={MoreChannel} />
              <Route path="/mycoupon" component={MyPunchCoupon} />
            </Switch>
            {/* </Suspense> */}
          </BrowserRouter>
        </div>
      )
    }
    return <div></div>
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx